import React from 'react';
import SEO from '../components/common/SEO';
import ServiceHeroSection from '../components/services/ServiceHeroSection';
import ServiceMarqueeBar from '../components/services/ServiceMarqueeBar';
import ServiceDetailSection from '../components/services/ServiceDetailSection';
import ServiceFaqSection from '../components/services/ServiceFaqSection';
import ServicePricingSection from '../components/services/ServicePricingSection';

const Services = () => {
  return (
    <main className="w-full min-h-screen bg-[#f9f9f5]">
      <SEO
        title="Services & Pricing"
        description="Explore our simple website setup, design customization, and web hosting services with transparent pricing and no hidden fees."
        keywords="website design pricing, web hosting setup, website customization, custom website cost"
      />
      <ServiceHeroSection />
      <ServiceMarqueeBar />
      <ServiceDetailSection />
      <ServiceFaqSection />
      <ServicePricingSection />
    </main>
  );
};

export default Services;
